import React, { FC } from 'react';
import { type IconV2Props } from '../../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../../IconV2.scss';

const HowItWorks2: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`, className)}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#000" fillRule="nonzero">
      <path d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm0 1C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Z" />
      <path d="M19.32 21h-7.68v-.766c0-.604.19-1.205.57-1.804.376-.6.897-1.146 1.563-1.64.292-.21.524-.37.696-.485.172-.11.422-.276.75-.5.192-.13.416-.308.672-.532.25-.213.45-.421.601-.625.146-.192.271-.432.375-.718.104-.287.156-.581.156-.883 0-.339-.052-.628-.156-.867-.11-.23-.252-.394-.43-.492a1.991 1.991 0 0 0-.507-.204 1.839 1.839 0 0 0-.508-.023c-.51 0-.886.174-1.125.523-.24.344-.346.805-.32 1.383l-2.266-.46c.047-.46.156-.881.328-1.266.167-.38.401-.714.703-1 .307-.292.698-.519 1.172-.68.469-.162 1.018-.242 1.649-.242.635 0 1.197.086 1.687.258.484.177.878.421 1.18.734.302.318.526.677.672 1.078.145.406.218.857.218 1.352a3.2 3.2 0 0 1-.242 1.234 4.208 4.208 0 0 1-.656 1.078c-.287.328-.586.61-.899.844a6.98 6.98 0 0 1-1.03.672c-.569.307-1.139.68-1.712 1.117-.562.432-.872.779-.93 1.039h5.47V21Z" />
    </g>
  </svg>
);

export default HowItWorks2;
